import { type ColorParams, StrokeType } from '@bynder-studio/misc';
import { IStructuredGlyph } from '@bynder-studio/structured-text';
import { Position } from '../../Shared/Position';
import { BaseCompElement, BaseCompElementParams } from './BaseCompElement';
import { RadialGradientSize } from '../../../Helpers/utils';

export type SvgCompElementParams = BaseCompElementParams & {
    path: string;
    decorationPaths?: string[];
    horizontalPathScale: number;
    verticalPathScale: number;
    color: ColorParams;
    pathPosition: Position;
    strokeType: StrokeType;
    strokeWidth: number;
    radialGradientSize: RadialGradientSize;
};

export class SvgCompElement extends BaseCompElement {
    path!: string;

    decorationPaths?: string[];

    horizontalPathScale = 1; // horizontal scaling to apply to SVG

    verticalPathScale = 1; // vertical scaling to apply to SVG

    color: ColorParams = { type: 'SOLID', red: 0, green: 0, blue: 0, opacity: 1, brandColorId: null };

    // position to draw from (can be different from topleft)
    pathPosition!: Position;

    strokeType = StrokeType.NONE;

    strokeWidth = 0;

    radialGradientSize: RadialGradientSize = 'outcircle';

    glyph?: IStructuredGlyph['data'];

    setProperties(params: SvgCompElementParams) {
        super.setProperties(params);
        this.path = params.path ?? this.path;
        this.decorationPaths = params.decorationPaths ?? this.decorationPaths;
        this.horizontalPathScale = params.horizontalPathScale ?? this.horizontalPathScale;
        this.verticalPathScale = params.verticalPathScale ?? this.verticalPathScale;
        this.color = params.color;
        this.pathPosition = params.pathPosition
            ? new Position(params.pathPosition.x, params.pathPosition.y)
            : this.pathPosition;
        this.strokeType = params.strokeType || StrokeType.NONE;
        this.strokeWidth = params.strokeWidth || 0;
        this.radialGradientSize = params.radialGradientSize ?? this.radialGradientSize;
    }

    getLocalHashData() {
        return {
            ...super.getLocalHashData(),
            path: this.path,
            horizontalPathScale: this.horizontalPathScale,
            verticalPathScale: this.verticalPathScale,
            color: this.color,
            pathPosition: this.pathPosition.toObject(),
        };
    }

    toObject() {
        return {
            ...super.toObject(),
            type: 'SVG',
            path: this.path,
            decorationPaths: this.decorationPaths,
            horizontalPathScale: this.horizontalPathScale,
            verticalPathScale: this.verticalPathScale,
            color: this.color,
            pathPosition: this.pathPosition.toObject(),
            strokeType: this.strokeType,
            strokeWidth: this.strokeWidth,
            radialGradientSize: this.radialGradientSize,
            glyph: this.glyph,
        };
    }
}
